window.addEventListener('klaviyoForms', function (e) {
    if (e.detail.type === 'submit') {
      pintrk('track', 'lead', {
        lead_type: 'Newsletter',
      });
      qp('track', 'GenerateLead');
      if (window.gtag) {
        window.gtag('event', 'PopUp', {
          event_category: 'Email Subscribe',
          event_label: window.location.href,
          value: 1,
        });
      }
    }
});